export const ru = {
    CLICKS: 'Клики',
    CPC: 'CPC',
    CPM: 'CPM',
    CTR: 'CTR',
    DEAL_TYPE: 'Тип',
    MIN_PRICE: 'Мин. цена тыс. показов',
    NAME: 'Название',
    SHOWS: 'Показы',
    SPENT: 'Расходы',
    STATUS: 'Статус',
    'settings-deals': 'Параметры сделки',
    'without-nds': 'Без учета НДС'
};
